// extracted by mini-css-extract-plugin
export var infoItem = "_nl-2";
export var title = "_nl-0";
export var value = "_nl-1";